module.exports = __webpack_public_path__ + "resources/img/img_ahnlabv3_net_server_jp.a875d0e194bfc6b3fa171b7637af8e8a.png";